import { formatAmount } from "../../HelperFunctions/PayrollEntryHelpers/payrollFormatters";
import { ITEM_TYPE } from "../../Enums/Enum";

export const mapEmployeeNameOptions = (employees = []) => {
  const list = Array.isArray(employees) ? employees : [];
  const seen = new Set();

  return list.reduce((acc, employee) => {
    const rawName =
      typeof employee === "string"
        ? employee
        : employee?.EmpName ||
        employee?.EmployeeName ||
        employee?.Name ||
        employee?.name ||
        "";

    const employeeId = String(
      employee?.EmployeeID ||
      employee?.EmployeeId ||
      employee?.ID ||
      employee?.Id ||
      ""
    ).trim();

    const name = String(rawName || "").trim();
    if (!name) return acc;

    const key = name.toLowerCase();
    if (seen.has(key)) return acc;

    seen.add(key);
    acc.push({ label: name, value: name, employeeId });
    return acc;
  }, []);
};

export const extractEmployeePayrollDetails = (data, displayHours, isHoursDecimal) => {
  const cleanName = (val) => {
    const s = String(val || "").trim();
    return s && s !== "." ? s : "";
  };

  const wagesData = (data.EmpPayrollDetails || []).filter(
    (x) => x.ItemType === ITEM_TYPE.Wages
  ).map(item => {
    const rawImportedName = item.ImportedItemName || item.ItemName || "";
    const mappedTo = item.TargetID || item.PayrollItemID || "";
    const mappedToName = item.ItemName || "";
    const coaId = item.COA || item.AccountID || "";
    const coaName = cleanName(item.COAName || item.AccountName);

    return {
      id: item.PayrollDetailID || item.Id,
      wageName: rawImportedName,
      mappedTo,
      mappedToName,
      coa: coaId,
      coaName: coaName,
      hrs: displayHours(item.TotalHours || item.Hours || item.Hrs || 0, isHoursDecimal),
      rate: formatAmount(item.Rate || 0),
      gross: formatAmount(item.GrossPay || item.Amount || 0),
    };
  });
  
  const apiRates = {};
  wagesData.forEach(w => apiRates[w.id] = w.rate);

  const addDedData = (data.EmpPayrollDetails || []).filter(
    (x) => x.ItemType === ITEM_TYPE.Additions || x.ItemType === ITEM_TYPE.Deductions
  ).map(item => {
    const rawImportedName = item.ImportedItemName || item.ItemName || "";
    const mappedTo = item.TargetID || item.PayrollItemID || "";
    const mappedToName = item.ItemName || "";
    const coaId = item.COA || item.AccountID || "";
    const coaName = cleanName(item.COAName || item.AccountName);

    return {
      id: item.PayrollDetailID || item.Id,
      addDeduction: item.ItemType,
      item: rawImportedName,
      mappedTo,
      mappedToName,
      coa: coaId,
      coaName: coaName,
      amount: formatAmount(item.Amount || 0),
    };
  });

  const taxesData = (data.EmpPayrollDetails || []).filter(
    (x) => x.ItemType === ITEM_TYPE.EmployeeTaxes || x.ItemType === ITEM_TYPE.EmployerTaxes
  ).map(item => {
    const rawImportedName = item.ImportedItemName || item.ItemName || "";
    const mappedTo = item.TargetID || item.PayrollItemID || "";
    const mappedToName = item.ItemName || "";
    const coaId = item.COA || item.AccountID || "";
    const coaName = cleanName(item.COAName || item.AccountName);

    return {
      id: item.PayrollDetailID || item.Id,
      taxType: item.ItemType,
      item: rawImportedName,
      mappedTo,
      mappedToName,
      coa: coaId,
      expenseCoa: item.LiabilityAccountID || item.ExpenseAccountID || item.ExpenseCOA || "",
      coaName: coaName,
      amount: formatAmount(item.Amount || 0),
    };
  });

  return { wagesData, apiRates, addDedData, taxesData };
};